export const SLPFileLang = {
    upload: 'فایل خود را بکشید و رها کنید',
    uploadBtn: 'آپلود فایل',
    dnd: 'فایل خود را بکشید و رها کنید',
    err: 'خطایی در آپلود رخ داده است,لطفا دوباره تلاش نمایید',
    err400: 'نوع فایل قابل پذیرش نیست. لطفا فایل با فرمت دیگری را آپلود کنید.',
    maxSizeErr: 'حجم فایل آپلود شده بیشتر از حد مجاز است. لطفا فایل کم حجم تری آپلود کنید.',
};
